import React, { useState, useContext, useLayoutEffect } from 'react';
import PricingContext from '../../../context/pricing';
import withSelections from '../withSelections';
import StyledFooter from './styles';
import Modal from '../Modal';
import Cart from '../Cart';
import Addons from '../Addons';
import { SIGNUP_URL } from '../../../constants/pricing/config';
import { trackCheckout, startFree } from '../../../utils/pricing';

const FixedFooter = (props) => {
  const { eiPackage, mcPackage, hasPaidPlan } = props;
  const [isOpen, toggleModal] = useState();
  const { state, sgPricingVersion, isFullPricing } = useContext(PricingContext);

  /**
   * Show the fixed footer when there is something other than the
   * default MC & EI plans in the cart and the checkout (addon) modal isn't open.
   */
  const showFixedFooter = (mcPackage || eiPackage) && !isOpen;

  const bottomOffset = showFixedFooter ? 0 : -200;

  useLayoutEffect(() => {
    if (showFixedFooter) {
      document.body.classList.add('fixed-footer-open');
    } else {
      document.body.classList.remove('fixed-footer-open');
    }
  }, [showFixedFooter]);

  return (
    <>
      <StyledFooter style={{ bottom: bottomOffset }}>
        <div className="row row--large">
          <Cart addons={false} />
          <div>
            {isFullPricing && hasPaidPlan ? (
              <button
                type="button"
                className="btn btn--primary"
                data-testid="cta-checkout"
                onClick={startFree}
              >
                Get Started
              </button>
            ) : (
              <a
                href={SIGNUP_URL}
                onClick={() => trackCheckout(state, sgPricingVersion)}
                className="btn btn--primary"
              >
                Checkout
              </a>
            )}
          </div>
        </div>
      </StyledFooter>
      <Modal isOpen={isOpen} close={toggleModal} contentLabel="Checkout">
        <div className="row row--small text-center">
          <h2>Select Your Add-ons</h2>
          <p>
            Select your add-ons and continue to checkout. Not sure?
            <br />
            You can add in-app at a later time.
          </p>
        </div>
        <Cart addons />
        <Addons />
      </Modal>
    </>
  );
};

export default withSelections(FixedFooter);
